import { cell, pickField } from "@/utility/fclReportFieldUtils";
import {
    clipText,
    dateReportCol,
    fileRefLinkCell,
    pickSort,
    reportCol,
} from "./importReportColumnUtils";

const trimDisplay = (value) => {
    const text = cell(value);
    return text === "-" ? "" : String(text).trim();
};

const formatPlaceOfDelivery = (row) =>
    trimDisplay(
        pickField(row, [
            "shipezPlaceOfDeliveryCustomized",
            "ShipezPlaceOfDeliveryCustomized",
            "shipezPlaceOfDelivery",
            "ShipezPlaceOfDelivery",
            "carrierPlaceOfDelivery_Customized",
            "CarrierPlaceOfDelivery_Customized",
            "carrierPlaceOfDelivery",
            "CarrierPlaceOfDelivery",
        ])
    );

export const IMPORT_ACTIVE_SHIPMENT_LIST_COLUMNS = [
    reportCol({
        key: "fileRefNumber",
        label: "File Reference Number",
        width: 155,
        sticky: "left",
        render: (row) =>
            fileRefLinkCell(
                trimDisplay(
                    pickField(row, ["fileRefNumber", "FileRefNumber", "fileRefNo", "FileRefNo"])
                )
            ),
        getTooltip: (row) =>
            trimDisplay(
                pickField(row, ["fileRefNumber", "FileRefNumber", "fileRefNo", "FileRefNo"])
            ),
        sortValue: (row) =>
            pickSort(row, ["fileRefNumber", "FileRefNumber", "fileRefNo", "FileRefNo"]),
    }),
    reportCol({
        key: "consignee",
        label: "Consignee",
        width: 200,
        render: (row) => clipText(pickField(row, ["consignee", "Consignee"])),
        sortValue: (row) => pickSort(row, ["consignee", "Consignee"]),
    }),
    reportCol({
        key: "customerPONumber",
        label: "Customer PO Number",
        width: 140,
        render: (row) => clipText(pickField(row, ["customerPONumber", "CustomerPONumber"])),
        sortValue: (row) => pickSort(row, ["customerPONumber", "CustomerPONumber"]),
    }),
    reportCol({
        key: "shipper",
        label: "Shipper",
        width: 200,
        render: (row) => clipText(pickField(row, ["shipper", "Shipper"])),
        sortValue: (row) => pickSort(row, ["shipper", "Shipper"]),
    }),
    reportCol({
        key: "overseasAgent",
        label: "Overseas Agent",
        width: 160,
        render: (row) => clipText(pickField(row, ["overseasAgent", "OverseasAgent"])),
        sortValue: (row) => pickSort(row, ["overseasAgent", "OverseasAgent"]),
    }),
    reportCol({
        key: "containerNo",
        label: "Container Number",
        width: 165,
        render: (row) =>
            clipText(
                pickField(row, ["containerNo", "ContainerNo", "containerNumber", "ContainerNumber"]),
                "font-mono text-[12px]"
            ),
        sortValue: (row) =>
            pickSort(row, ["containerNo", "ContainerNo", "containerNumber", "ContainerNumber"]),
    }),
    reportCol({
        key: "containerSize",
        label: "Container Size",
        width: 130,
        render: (row) => clipText(pickField(row, ["containerSize", "ContainerSize"])),
        sortValue: (row) => pickSort(row, ["containerSize", "ContainerSize"]),
    }),
    reportCol({
        key: "carrier",
        label: "Carrier",
        width: 140,
        render: (row) => clipText(pickField(row, ["carrier", "Carrier"])),
        sortValue: (row) => pickSort(row, ["carrier", "Carrier"]),
    }),
    reportCol({
        key: "carrierMBL",
        label: "Carrier Master B/L Number",
        width: 165,
        render: (row) =>
            clipText(pickField(row, ["carrierMBL", "CarrierMBL", "carrierMbl"]), "font-mono text-[12px]"),
        sortValue: (row) => pickSort(row, ["carrierMBL", "CarrierMBL", "carrierMbl"]),
    }),
    dateReportCol({
        key: "customsReleaseDate",
        label: "Customs Release Date",
        width: 155,
        fieldKeys: ["customsReleaseDate", "CustomsReleaseDate"],
    }),
    dateReportCol({
        key: "carrierReleaseDate",
        label: "Carrier Release Date",
        width: 155,
        fieldKeys: ["carrierReleaseDate", "CarrierReleaseDate"],
    }),
    reportCol({
        key: "pol",
        label: "POL",
        width: 175,
        render: (row) => clipText(pickField(row, ["pol", "POL"])),
        sortValue: (row) => pickSort(row, ["pol", "POL"]),
    }),
    dateReportCol({
        key: "poletd",
        label: "POL ETD",
        width: 130,
        fieldKeys: ["poletd", "PolEtd", "polETD", "polEtd"],
    }),
    reportCol({
        key: "motherVesselNameVoyage",
        label: "Mother Vessel Name / Voyage",
        width: 210,
        render: (row) =>
            clipText(
                pickField(row, ["motherVesselNameVoyage", "MotherVesselNameVoyage"])
            ),
        getTooltip: (row) =>
            pickField(row, ["motherVesselNameVoyage", "MotherVesselNameVoyage"]) || "",
        sortValue: (row) => pickSort(row, ["motherVesselNameVoyage", "MotherVesselNameVoyage"]),
    }),
    reportCol({
        key: "pod",
        label: "POD",
        width: 175,
        render: (row) => clipText(pickField(row, ["pod", "POD"])),
        sortValue: (row) => pickSort(row, ["pod", "POD"]),
    }),
    dateReportCol({
        key: "podeta",
        label: "POD ETA",
        width: 130,
        fieldKeys: ["podeta", "PodEta", "podETA", "podEta"],
    }),
    reportCol({
        key: "placeOfDelivery",
        label: "Place of Delivery",
        width: 200,
        render: (row) => clipText(formatPlaceOfDelivery(row)),
        getTooltip: (row) => formatPlaceOfDelivery(row),
        sortValue: (row) => formatPlaceOfDelivery(row).toLowerCase(),
    }),
    dateReportCol({
        key: "appointmentDateTime",
        label: "Appointment Date/Time",
        width: 165,
        fieldKeys: [
            "appointmentDateTime",
            "AppointmentDateTime",
            "appointmentDate",
            "AppointmentDate",
            "container_AppointmentDate",
            "Container_AppointmentDate",
        ],
    }),
    reportCol({
        key: "comments",
        label: "Comments",
        width: 180,
        render: (row) =>
            clipText(
                pickField(row, [
                    "comments",
                    "Comments",
                    "shipmentComments",
                    "ShipmentComments",
                    "intermodalComments",
                    "IntermodalComments",
                    "container_IntermodalComments",
                    "Container_IntermodalComments",
                    "reportComments",
                    "ReportComments",
                ])
            ),
        sortValue: (row) =>
            pickSort(row, [
                "comments",
                "Comments",
                "shipmentComments",
                "ShipmentComments",
                "intermodalComments",
                "IntermodalComments",
                "container_IntermodalComments",
                "Container_IntermodalComments",
                "reportComments",
                "ReportComments",
            ]),
    }),
];

/** @deprecated Use IMPORT_ACTIVE_SHIPMENT_LIST_COLUMNS */
export const IMPORT_ACTIVE_SHIPMENT_COLUMNS = IMPORT_ACTIVE_SHIPMENT_LIST_COLUMNS;
